// import React, { useEffect, useRef, useState } from "react";
// import { GoogleMap, useJsApiLoader, Marker, DirectionsRenderer, InfoWindow } from "@react-google-maps/api";

// const containerStyle = {
//   width: "100%",
//   height: "500px",
// };

// const DirectionMap = ({ directionData }) => {
//   const mapRef = useRef(null);
//   const [showInfo, setShowInfo] = useState(false);

//   const { isLoaded } = useJsApiLoader({
//     id: "google-map-script",
//     googleMapsApiKey: "AIzaSyA8Io_sD3d5uTz6ZTj4FKae_I7mdBVjX9o"
//   });

//   const latitude = Number(directionData?.Latitude)
//   const longitude = Number(directionData?.Longitude)

//   useEffect(() => {
//     if (mapRef.current && directionData) {
//       const bounds = new window.google.maps.LatLngBounds();
//       bounds.extend({
//         lat: latitude,
//         lng: longitude
//       });
//       mapRef.current.fitBounds(bounds);
//     }
//   }, [directionData]);

//   if (!isLoaded || !directionData) return null;

//   return (
//     <GoogleMap
//       mapContainerStyle={containerStyle}
//       center={{
//         lat: latitude,
//         lng: longitude
//       }}
//       zoom={15}
//       onLoad={(map) => (mapRef.current = map)}
//       options={{
//         zoomControl: true,
//         mapTypeControl: false,
//         streetViewControl: false,
//         fullscreenControl: true,
//         styles: [{ featureType: "poi.business", elementType: "labels", stylers: [{ visibility: "off" }] }],
//       }}
//     >
//       <Marker
//         position={{
//           lat: latitude,
//           lng: longitude
//         }}
//         onClick={() => setShowInfo(true)}
//         icon={{
//           url: "/iconImages/green.png",
//           scaledSize: new window.google.maps.Size(32, 32),
//           anchor: new window.google.maps.Point(20, 40)
//         }}
//       />

//       {/* Info Window */}
//       {showInfo && (
//         <InfoWindow
//           position={{
//             lat: latitude,
//             lng: longitude
//           }}
//           onCloseClick={() => setShowInfo(false)}
//         >
//           <div className="text-sm space-y-1 text-left">
//             <div className="font-semibold text-gray-800">
//               🏪 Shop Location
//             </div>

//             <div className="text-gray-600">
//               {directionData?.Address || "Address not available"}
//             </div>

//             <div className="text-xs text-gray-500">
//               Latitude: {latitude}
//               <br />
//               Longitude: {longitude}
//             </div>
//           </div>
//         </InfoWindow>
//       )}

//     </GoogleMap>
//   );
// };

// export default DirectionMap;

// import React, { useEffect, useState } from "react";
// import { GoogleMap, useJsApiLoader, Marker, DirectionsRenderer, InfoWindow } from "@react-google-maps/api";

// const containerStyle = {
//   width: "100%",
//   height: "500px",
// };

// const DirectionMap = ({ directionData }) => {
//   const [map, setMap] = useState(null);
//   const [userLocation, setUserLocation] = useState(null);
//   const [directionsResponse, setDirectionsResponse] = useState(null);
//   const [locationError, setLocationError] = useState(null);
//   const [showInfo, setShowInfo] = useState(false);

//   const { isLoaded } = useJsApiLoader({
//     id: "google-map-script",
//     googleMapsApiKey: "AIzaSyA8Io_sD3d5uTz6ZTj4FKae_I7mdBVjX9o",
//   });

//   const shopLat = Number(directionData?.Latitude);
//   const shopLng = Number(directionData?.Longitude);

//   const hasValidShopLocation = !isNaN(shopLat) && !isNaN(shopLng) && shopLat !== 0 && shopLng !== 0;

//   // 🔹 Request User Location
//   const requestUserLocation = () => {
//     if (!navigator.geolocation) {
//       setLocationError("Geolocation is not supported by your browser.");
//       return;
//     }
//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         const loc = {
//           lat: position.coords.latitude,
//           lng: position.coords.longitude,
//         };
//         setUserLocation(loc);
//         setLocationError(null);
//       },
//       (error) => {
//         if (error.code === error.PERMISSION_DENIED) {
//           setLocationError("User denied Geolocation");
//         } else if (error.code === error.POSITION_UNAVAILABLE) {
//           setLocationError("Location information is unavailable.");
//         } else if (error.code === error.TIMEOUT) {
//           setLocationError("Location request timed out.");
//         } else {
//           setLocationError("An unknown error occurred.");
//         }
//       },
//       { enableHighAccuracy: true, timeout: 10000 },
//     );
//   };

//   // Ask location once map loads
//   useEffect(() => {
//     if (!isLoaded) return;
//     checkLocationPermission();
//     requestUserLocation();
//   }, [isLoaded]);

//   const checkLocationPermission = async () => {
//     if (!navigator.permissions) return;

//     const permission = await navigator.permissions.query({
//       name: "geolocation",
//     });

//     if (permission.state === "denied") {
//       setLocationError("Location access is blocked. Please enable it from browser settings.");
//     }

//     permission.onchange = () => {
//       if (permission.state === "granted") {
//         requestUserLocation();
//       }
//     };
//   };

//   // 🔹 Fetch Directions
//   useEffect(() => {
//     if (!isLoaded || !userLocation || !hasValidShopLocation) return;

//     const directionsService = new window.google.maps.DirectionsService();

//     directionsService.route(
//       {
//         origin: userLocation,
//         destination: { lat: shopLat, lng: shopLng },
//         travelMode: window.google.maps.TravelMode.DRIVING,
//       },
//       (result, status) => {
//         if (status === "OK") {
//           setDirectionsResponse(result);
//         } else {
//           setLocationError("Could not calculate directions.");
//         }
//       },
//     );
//   }, [isLoaded, userLocation, hasValidShopLocation, shopLat, shopLng]);

//   // 🔹 Auto fit route
//   useEffect(() => {
//     if (map && directionsResponse) {
//       map.fitBounds(directionsResponse.routes[0].bounds);
//     }
//   }, [map, directionsResponse]);

//   if (!isLoaded) return <div className="p-4 text-center">Loading map...</div>;

//   if (!directionData || !hasValidShopLocation) return <div className="p-4 text-center text-red-600">Shop location coordinates are missing or invalid.</div>;

//   return (
//     <div className="relative">
//       <GoogleMap
//         mapContainerStyle={containerStyle}
//         center={{ lat: shopLat, lng: shopLng }}
//         zoom={15}
//         onLoad={(map) => setMap(map)}
//         options={{
//           zoomControl: true,
//           mapTypeControl: false,
//           streetViewControl: false,
//           fullscreenControl: true,
//         }}
//       >
//         {/* 🏪 Shop Marker */}
//         <Marker
//           position={{ lat: shopLat, lng: shopLng }}
//           onClick={() => setShowInfo(true)}
//           icon={{
//             url: "/iconImages/green.png",
//             scaledSize: new window.google.maps.Size(32, 32),
//           }}
//         />

//         {/* 📍 User Default Blue Marker */}
//         {userLocation && <Marker position={userLocation} />}

//         {/* 🗺️ Route */}
//         {directionsResponse && (
//           <DirectionsRenderer
//             directions={directionsResponse}
//             options={{
//               suppressMarkers: true,
//               polylineOptions: {
//                 strokeColor: "#1E88E5",
//                 strokeWeight: 5,
//               },
//             }}
//           />
//         )}

//         {/* Info Window */}
//         {showInfo && (
//           <InfoWindow position={{ lat: shopLat, lng: shopLng }} onCloseClick={() => setShowInfo(false)}>
//             <div className="text-sm">
//               <div className="font-semibold">🏪 Shop Location</div>
//               <div>{directionData?.Address || "Address not available"}</div>
//             </div>
//           </InfoWindow>
//         )}
//       </GoogleMap>

//       {/* 🔴 Location Error UI */}
//       {locationError && (
//         <div className="absolute bottom-4 left-4 bg-red-100 text-red-700 px-4 py-2 rounded shadow-md text-sm max-w-xs">
//           {locationError}

//           <div className="mt-2">
//             <button onClick={requestUserLocation} className="bg-blue-600 text-white px-3 py-1 rounded text-xs">
//               Try Again
//             </button>
//           </div>

//           <div className="text-xs mt-2 text-gray-600">If blocked, click 🔒 in address bar → Allow Location → Refresh.</div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DirectionMap;

// import React, { useEffect, useState, useCallback, useRef } from "react";
// import { GoogleMap, useJsApiLoader, Marker, DirectionsRenderer, InfoWindow } from "@react-google-maps/api";

// const containerStyle = {
//   width: "100%",
//   height: "500px",
// };

// const DirectionMap = ({ directionData }) => {
//   const [map, setMap] = useState(null);
//   const [userLocation, setUserLocation] = useState(null);
//   const [directionsResponse, setDirectionsResponse] = useState(null);
//   const [locationError, setLocationError] = useState(null);
//   const [showInfo, setShowInfo] = useState(false);
//   const [isRequestingLocation, setIsRequestingLocation] = useState(false);
//   const [showManualInput, setShowManualInput] = useState(false);
//   const [manualAddress, setManualAddress] = useState("");

//   const geocoderRef = useRef(null);

//   const { isLoaded } = useJsApiLoader({
//     id: "google-map-script",
//     googleMapsApiKey: "AIzaSyA8Io_sD3d5uTz6ZTj4FKae_I7mdBVjX9o", // Use env variable
//     // libraries: ["places"], // for geocoding
//   });

//   const shopLat = Number(directionData?.Latitude);
//   const shopLng = Number(directionData?.Longitude);
//   const hasValidShopLocation = !isNaN(shopLat) && !isNaN(shopLng) && shopLat !== 0 && shopLng !== 0;

//   // 🔹 Request user location with high accuracy
//   const requestUserLocation = useCallback(() => {
//     if (!navigator.geolocation) {
//       setLocationError("Geolocation is not supported by your browser.");
//       return;
//     }

//     setIsRequestingLocation(true);
//     setLocationError(null);

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         const loc = {
//           lat: position.coords.latitude,
//           lng: position.coords.longitude,
//         };
//         setUserLocation(loc);
//         setLocationError(null);
//         setIsRequestingLocation(false);
//       },
//       (error) => {
//         setIsRequestingLocation(false);
//         let message = "";
//         if (error.code === error.PERMISSION_DENIED) {
//           message = "Location access was denied. You can try again or enter an address manually.";
//         } else if (error.code === error.POSITION_UNAVAILABLE) {
//           message = "Location information is unavailable. Please enter an address manually.";
//         } else if (error.code === error.TIMEOUT) {
//           message = "Location request timed out. Please try again or enter an address.";
//         } else {
//           message = "An unknown error occurred.";
//         }
//         setLocationError(message);
//       },
//       { enableHighAccuracy: true, timeout: 10000 },
//     );
//   }, []);

//   // 🔹 Check permission status (optional, but helpful)
//   const checkLocationPermission = useCallback(async () => {
//     if (!navigator.permissions) return;
//     try {
//       const permission = await navigator.permissions.query({ name: "geolocation" });
//       if (permission.state === "denied") {
//         setLocationError("Location access is blocked. Please enable it in your browser settings.");
//       }
//       permission.onchange = () => {
//         if (permission.state === "granted") {
//           requestUserLocation();
//         }
//       };
//     } catch (err) {
//       // Permissions API not fully supported or error – ignore
//     }
//   }, [requestUserLocation]);

//   // 🔹 Handle manual address entry
//   const handleManualAddressSubmit = () => {
//     if (!manualAddress.trim() || !window.google) return;

//     if (!geocoderRef.current) {
//       geocoderRef.current = new window.google.maps.Geocoder();
//     }

//     geocoderRef.current.geocode({ address: manualAddress }, (results, status) => {
//       if (status === "OK" && results[0]) {
//         const location = results[0].geometry.location;
//         setUserLocation({ lat: location.lat(), lng: location.lng() });
//         setLocationError(null);
//         setShowManualInput(false);
//         setManualAddress("");
//       } else {
//         setLocationError("Could not find that address. Please try again.");
//       }
//     });
//   };

//   // 🔹 Initial location request
//   useEffect(() => {
//     if (!isLoaded) return;
//     checkLocationPermission();
//     requestUserLocation();
//   }, [isLoaded, checkLocationPermission, requestUserLocation]);

//   // 🔹 Fetch directions once userLocation and shop are valid
//   useEffect(() => {
//     if (!isLoaded || !userLocation || !hasValidShopLocation) return;

//     const directionsService = new window.google.maps.DirectionsService();

//     directionsService.route(
//       {
//         origin: userLocation,
//         destination: { lat: shopLat, lng: shopLng },
//         travelMode: window.google.maps.TravelMode.DRIVING,
//       },
//       (result, status) => {
//         if (status === "OK") {
//           setDirectionsResponse(result);
//         } else {
//           setLocationError("Could not calculate directions.");
//         }
//       },
//     );
//   }, [isLoaded, userLocation, hasValidShopLocation, shopLat, shopLng]);

//   // 🔹 Fit map to route bounds when directions are ready
//   useEffect(() => {
//     if (map && directionsResponse) {
//       map.fitBounds(directionsResponse.routes[0].bounds);
//     }
//   }, [map, directionsResponse]);

//   // 🔹 Center map on user location (button action)
//   const centerOnUser = () => {
//     if (map && userLocation) {
//       map.panTo(userLocation);
//       map.setZoom(15);
//     }
//   };

//   if (!isLoaded) return <div className="p-4 text-center">Loading map...</div>;

//   if (!directionData || !hasValidShopLocation) {
//     return <div className="p-4 text-center text-red-600">Shop location coordinates are missing or invalid.</div>;
//   }

//   return (
//     <div className="relative">
//       <GoogleMap
//         mapContainerStyle={containerStyle}
//         center={{ lat: shopLat, lng: shopLng }}
//         zoom={15}
//         onLoad={(map) => setMap(map)}
//         options={{
//           zoomControl: true,
//           mapTypeControl: false,
//           streetViewControl: false,
//           fullscreenControl: true,
//         }}
//       >
//         {/* 🏪 Shop Marker */}
//         <Marker
//           position={{ lat: shopLat, lng: shopLng }}
//           onClick={() => setShowInfo(true)}
//           icon={{
//             url: "/iconImages/green.png",
//             scaledSize: new window.google.maps.Size(32, 32),
//           }}
//         />

//         {/* 📍 User Location Marker (default blue) */}
//         {userLocation && <Marker position={userLocation} />}

//         {/* 🗺️ Directions */}
//         {directionsResponse && (
//           <DirectionsRenderer
//             directions={directionsResponse}
//             options={{
//               suppressMarkers: true,
//               polylineOptions: {
//                 strokeColor: "#1E88E5",
//                 strokeWeight: 5,
//               },
//             }}
//           />
//         )}

//         {/* ℹ️ Shop Info Window */}
//         {showInfo && (
//           <InfoWindow position={{ lat: shopLat, lng: shopLng }} onCloseClick={() => setShowInfo(false)}>
//             <div className="text-sm">
//               <div className="font-semibold">🏪 Shop Location</div>
//               <div>{directionData?.Address || "Address not available"}</div>
//             </div>
//           </InfoWindow>
//         )}
//       </GoogleMap>

//       {/* 🔴 Location Error / Manual Input UI */}
//       {locationError && (
//         <div className="absolute bottom-4 left-4 bg-red-100 text-red-700 px-4 py-3 rounded shadow-md text-sm max-w-xs">
//           <p>{locationError}</p>

//           <div className="mt-2 flex gap-2">
//             <button onClick={requestUserLocation} disabled={isRequestingLocation} className="bg-blue-600 text-white px-3 py-1 rounded text-xs disabled:opacity-50">
//               {isRequestingLocation ? "Requesting..." : "Try Again"}
//             </button>
//             <button onClick={() => setShowManualInput(true)} className="bg-gray-600 text-white px-3 py-1 rounded text-xs">
//               Enter Address
//             </button>
//           </div>

//           <div className="text-xs mt-2 text-gray-600">If blocked, click the 🔒 icon in the address bar → Allow Location → Refresh.</div>

//           {showManualInput && (
//             <div className="mt-3">
//               <input
//                 type="text"
//                 value={manualAddress}
//                 onChange={(e) => setManualAddress(e.target.value)}
//                 placeholder="Enter address or place"
//                 className="w-full p-1 border rounded text-xs"
//               />
//               <button onClick={handleManualAddressSubmit} className="mt-1 bg-green-600 text-white px-2 py-1 rounded text-xs">
//                 Set Location
//               </button>
//             </div>
//           )}
//         </div>
//       )}

//       {/* 🧭 Center on My Location button (appears when userLocation exists) */}
//       {userLocation && (
//         <button onClick={centerOnUser} className="absolute bottom-4 right-4 bg-white text-gray-800 px-3 py-2 rounded shadow-md text-sm border hover:bg-gray-100">
//           📍 Center on me
//         </button>
//       )}

//       {/* ⌛ Loading indicator while requesting location */}
//       {isRequestingLocation && !userLocation && (
//         <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-white px-4 py-2 rounded shadow-md text-sm">⏳ Getting your location...</div>
//       )}
//     </div>
//   );
// };

// export default DirectionMap;

import React, { useEffect, useState, useCallback, useRef } from "react";
import { GoogleMap, useJsApiLoader, Marker, DirectionsRenderer, InfoWindow } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "500px",
};

// Simple modal component – replace with your own modal library if preferred
const LocationHelpModal = ({ isOpen, onClose, onTryAgain, browser }) => {
  if (!isOpen) return null;

  const getBrowserInstructions = () => {
    switch (browser) {
      case "chrome":
        return (
          <>
            <p>
              1. Click the lock icon <span className="text-lg">🔒</span> in the address bar.
            </p>
            <p>
              2. Find <strong>Location</strong> and change it to <strong>Allow</strong>.
            </p>
            <p>
              3. Reload the page or click <strong>Try Again</strong>.
            </p>
          </>
        );
      case "firefox":
        return (
          <>
            <p>
              1. Click the lock icon <span className="text-lg">🔒</span>.
            </p>
            <p>
              2. Go to <strong>Permissions</strong> → Set <strong>Access Location</strong> to Allow.
            </p>
            <p>3. Reload the page.</p>
          </>
        );
      case "safari":
        return (
          <>
            <p>
              1. Click <strong>Safari → Settings for This Website</strong>.
            </p>
            <p>
              2. Set <strong>Location</strong> to <strong>Allow</strong>.
            </p>
            <p>3. Reload the page.</p>
          </>
        );
      case "edge":
        return (
          <>
            <p>
              1. Click the lock icon <span className="text-lg">🔒</span>.
            </p>
            <p>
              2. Under Permissions, set <strong>Location</strong> to Allow.
            </p>
            <p>3. Reload the page.</p>
          </>
        );
      default:
        return (
          <>
            <p>
              1. Click the lock icon <span className="text-lg">🔒</span>.
            </p>
            <p>
              2. Find <strong>Location</strong> and set it to <strong>Allow</strong>.
            </p>
            <p>3. Reload the page.</p>
          </>
        );
    }
  };

  return (
    <div className="fixed inset-0 bg-gray  flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="bg-gradient-to-r from-indigo-600 to-blue-600 px-6 py-4">
          <h3 className="text-white text-lg font-semibold flex items-center gap-2">📍 Enable Location Access</h3>
          <p className="text-indigo-100 text-sm mt-1">Allow location access to get directions from your current position.</p>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="bg-indigo-50 border border-indigo-100 rounded-lg p-4 text-sm text-gray-700 space-y-2 mb-6">{getBrowserInstructions()}</div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
            <button onClick={onTryAgain} className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-indigo-700 transition">
              Try Again
            </button>

            <button onClick={() => window.location.reload()} className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-200 transition">
              Refresh
            </button>

            <button onClick={onClose} className="border border-gray-300 text-gray-600 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-50 transition">
              Close
            </button>
          </div>

          <p className="text-xs text-gray-400 mt-5 text-center">You can also manually enter your address if location remains disabled.</p>
        </div>
      </div>
    </div>
  );
};

const DirectionMap = ({ directionData }) => {
  const [map, setMap] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [locationError, setLocationError] = useState(null);
  const [showInfo, setShowInfo] = useState(false);
  const [isRequestingLocation, setIsRequestingLocation] = useState(false);
  const [showManualInput, setShowManualInput] = useState(false);
  const [manualAddress, setManualAddress] = useState("");
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [browser, setBrowser] = useState("");

  const geocoderRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyA8Io_sD3d5uTz6ZTj4FKae_I7mdBVjX9o", // Use env variable
    // libraries: ["places"],
  });

  // Detect browser on mount
  useEffect(() => {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf("Chrome") > -1) setBrowser("chrome");
    else if (userAgent.indexOf("Firefox") > -1) setBrowser("firefox");
    else if (userAgent.indexOf("Safari") > -1) setBrowser("safari");
    else if (userAgent.indexOf("Edg") > -1) setBrowser("edge");
    else setBrowser("other");
  }, []);

  const shopLat = Number(directionData?.Latitude);
  const shopLng = Number(directionData?.Longitude);
  const hasValidShopLocation = !isNaN(shopLat) && !isNaN(shopLng) && shopLat !== 0 && shopLng !== 0;

  // 🔹 Request user location with high accuracy
  const requestUserLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setLocationError("Geolocation is not supported by your browser.");
      return;
    }

    setIsRequestingLocation(true);
    setLocationError(null);
    setShowManualInput(false);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const loc = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        setUserLocation(loc);
        setLocationError(null);
        setIsRequestingLocation(false);
        setShowHelpModal(false); // close help if open
      },
      (error) => {
        setIsRequestingLocation(false);
        let message = "";
        if (error.code === error.PERMISSION_DENIED) {
          message = "Location access was denied.";
          // Show the help modal with instructions
          setShowHelpModal(true);
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          message = "Location information is unavailable. Please enter an address manually.";
        } else if (error.code === error.TIMEOUT) {
          message = "Location request timed out. Please try again or enter an address.";
        } else {
          message = "An unknown error occurred.";
        }
        setLocationError(message);
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  }, []);

  // 🔹 Check permission status
  const checkLocationPermission = useCallback(async () => {
    if (!navigator.permissions) return;
    try {
      const permission = await navigator.permissions.query({ name: "geolocation" });
      if (permission.state === "denied") {
        setLocationError("Location access is blocked.");
        // Optionally show help modal immediately – but we'll wait for the actual request to trigger it
      }
      permission.onchange = () => {
        if (permission.state === "granted") {
          requestUserLocation();
        }
      };
    } catch (err) {
      // Permissions API not fully supported – ignore
    }
  }, [requestUserLocation]);

  // 🔹 Handle manual address entry
  const handleManualAddressSubmit = () => {
    if (!manualAddress.trim() || !window.google) return;

    if (!geocoderRef.current) {
      geocoderRef.current = new window.google.maps.Geocoder();
    }

    geocoderRef.current.geocode({ address: manualAddress }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        setUserLocation({ lat: location.lat(), lng: location.lng() });
        setLocationError(null);
        setShowManualInput(false);
        setManualAddress("");
        setShowHelpModal(false);
      } else {
        setLocationError("Could not find that address. Please try again.");
      }
    });
  };

  // 🔹 Initial location request
  useEffect(() => {
    if (!isLoaded) return;
    checkLocationPermission();
    requestUserLocation();
  }, [isLoaded, checkLocationPermission, requestUserLocation]);

  // 🔹 Fetch directions once userLocation and shop are valid
  useEffect(() => {
    if (!isLoaded || !userLocation || !hasValidShopLocation) return;

    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin: userLocation,
        destination: { lat: shopLat, lng: shopLng },
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          setDirectionsResponse(result);
        } else {
          setLocationError("Could not calculate directions.");
        }
      },
    );
  }, [isLoaded, userLocation, hasValidShopLocation, shopLat, shopLng]);

  // 🔹 Fit map to route bounds when directions are ready
  useEffect(() => {
    if (map && directionsResponse) {
      map.fitBounds(directionsResponse.routes[0].bounds);
    }
  }, [map, directionsResponse]);

  // 🔹 Center map on user location
  const centerOnUser = () => {
    if (map && userLocation) {
      map.panTo(userLocation);
      map.setZoom(15);
    }
  };

  if (!isLoaded) return <div className="p-4 text-center">Loading map...</div>;

  if (!directionData || !hasValidShopLocation) {
    return <div className="p-4 text-center text-red-600">Shop location coordinates are missing or invalid.</div>;
  }

  return (
    <div className="relative">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={{ lat: shopLat, lng: shopLng }}
        zoom={15}
        onLoad={(map) => setMap(map)}
        options={{
          zoomControl: true,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
        }}
      >
        {/* 🏪 Shop Marker */}
        <Marker
          position={{ lat: shopLat, lng: shopLng }}
          onClick={() => setShowInfo(true)}
          icon={{
            url: "/iconImages/green.png",
            scaledSize: new window.google.maps.Size(32, 32),
          }}
        />

        {/* 📍 User Location Marker */}
        {userLocation && <Marker position={userLocation} />}

        {/* 🗺️ Directions */}
        {directionsResponse && (
          <DirectionsRenderer
            directions={directionsResponse}
            options={{
              suppressMarkers: true,
              polylineOptions: {
                strokeColor: "#1E88E5",
                strokeWeight: 5,
              },
            }}
          />
        )}

        {/* ℹ️ Shop Info Window */}
        {showInfo && (
          <InfoWindow position={{ lat: shopLat, lng: shopLng }} onCloseClick={() => setShowInfo(false)}>
            <div className="text-sm">
              <div className="font-semibold">🏪 Shop Location</div>
              <div>{directionData?.Address || "Address not available"}</div>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>

      {/* 🆘 Help Modal */}
      <LocationHelpModal isOpen={showHelpModal} onClose={() => setShowHelpModal(false)} onTryAgain={requestUserLocation} browser={browser} />

      {/* 🔴 Location Error UI (if any, but help modal already covers permission denied) */}
      {locationError && !showHelpModal && (
        <div className="absolute bottom-4 left-4 bg-red-100 text-red-700 px-4 py-3 rounded shadow-md text-sm max-w-xs">
          <p>{locationError}</p>

          <div className="mt-2 flex gap-2 flex-wrap">
            <button onClick={requestUserLocation} disabled={isRequestingLocation} className="bg-blue-600 text-white px-3 py-1 rounded text-xs disabled:opacity-50">
              {isRequestingLocation ? "Requesting..." : "Try Again"}
            </button>
            <button onClick={() => setShowManualInput(true)} className="bg-gray-600 text-white px-3 py-1 rounded text-xs">
              Enter Address
            </button>
            {locationError.includes("denied") && (
              <button onClick={() => setShowHelpModal(true)} className="bg-purple-600 text-white px-3 py-1 rounded text-xs">
                How to enable?
              </button>
            )}
          </div>

          {showManualInput && (
            <div className="mt-3">
              <input
                type="text"
                value={manualAddress}
                onChange={(e) => setManualAddress(e.target.value)}
                placeholder="Enter address or place"
                className="w-full p-1 border rounded text-xs"
              />
              <button onClick={handleManualAddressSubmit} className="mt-1 bg-green-600 text-white px-2 py-1 rounded text-xs">
                Set Location
              </button>
            </div>
          )}
        </div>
      )}

      {/* 📍 Persistent GPS Button */}
      <button
        onClick={requestUserLocation}
        disabled={isRequestingLocation}
        className="absolute top-4 left-4 bg-white text-gray-800 px-3 py-2 rounded shadow-md text-sm border hover:bg-gray-100 disabled:opacity-50 flex items-center gap-1 z-10"
        title="Use my current location"
      >
        <span>📍</span> {isRequestingLocation ? "Locating..." : "Use my location"}
      </button>

      {/* 🧭 Center on My Location button */}
      {userLocation && (
        <button onClick={centerOnUser} className="absolute bottom-4 right-4 bg-white text-gray-800 px-3 py-2 rounded shadow-md text-sm border hover:bg-gray-100 z-10">
          🎯 Center on me
        </button>
      )}

      {/* ⌛ Loading indicator */}
      {isRequestingLocation && !userLocation && (
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-white px-4 py-2 rounded shadow-md text-sm z-10">⏳ Getting your location...</div>
      )}
    </div>
  );
};

export default DirectionMap;
